import React, { useEffect, useRef } from "react";

import { Flex, Text } from "@chakra-ui/react";

export const Group = ({ label, children, border, scrollToField, mt }) => {
  const anexoRef = useRef(null);

  useEffect(() => {
    scrollToField && scrollToField(anexoRef);
  }, [scrollToField]);

  return (
    <Flex
      flexDir="column"
      bgColor="#FFFFFF"
      borderRadius="20px"
      px="15px"
      py="10px"
      mt={mt ? mt : "15px"}
      border={border ? border : ""}
      ref={anexoRef}
    >
      {label && (
        <Text lineHeight="17.6px" size="14px" fontWeight={700} color="#95BCBF">
          {label.toUpperCase()}
        </Text>
      )}
      {children}
    </Flex>
  );
};
